<a class="skip-link" href="#main-content">Skip to main content</a>
<mat-sidenav-container class="sidenav-container">
    <mat-sidenav #sidenav [mode]="isMobile ? 'over' : 'side'" [opened]="!isMobile" [autoFocus]="sidenavAutoFocus" class="rounded-none">
        <div class="brand">
            <a routerLink="/" class="brand-link" aria-label="Nubo — go to dashboard">
                <nubo-logo variant="lockup" size="md" [ariaLabel]="null"></nubo-logo>
            </a>
        </div>

        <!-- Plain anchors rather than mat-nav-list: the list's own 56px rows, ripple
             and typography had to be undone with a wall of ::ng-deep !important, and
             the item still had nowhere to put a trailing badge or dot. -->
        <nav class="nav" aria-label="Main">
            <p class="nav-group" id="nav-group-overview">Overview</p>
            <ul class="nav-list" aria-labelledby="nav-group-overview">
                <li>
                    <a class="nav-item" routerLink="/dashboard" routerLinkActive="is-active">
                        <mat-icon class="nav-icon" aria-hidden="true">dashboard</mat-icon>
                        <span class="nav-label">Dashboard</span>
                    </a>
                </li>
                <li>
                    <a class="nav-item" routerLink="/usage" routerLinkActive="is-active">
                        <mat-icon class="nav-icon" aria-hidden="true">monitoring</mat-icon>
                        <span class="nav-label">Usage</span>
                    </a>
                </li>
                <li>
                    <a class="nav-item" routerLink="/logs" routerLinkActive="is-active">
                        <mat-icon class="nav-icon" aria-hidden="true">manage_search</mat-icon>
                        <span class="nav-label">Logs</span>
                    </a>
                </li>
            </ul>

            <p class="nav-group" id="nav-group-context">Context</p>
            <ul class="nav-list" aria-labelledby="nav-group-context">
                <li>
                    <a class="nav-item" routerLink="/knowledge-base" routerLinkActive="is-active" data-tour="nav-knowledge-base">
                        <mat-icon class="nav-icon" aria-hidden="true">menu_book</mat-icon>
                        <span class="nav-label">Knowledge Base</span>
                    </a>
                </li>
                <li>
                    <a class="nav-item" routerLink="/evaluate" routerLinkActive="is-active">
                        <mat-icon class="nav-icon" aria-hidden="true">science</mat-icon>
                        <span class="nav-label">Evaluate</span>
                    </a>
                </li>
                <li>
                    <a class="nav-item" routerLink="/settings" routerLinkActive="is-active" data-tour="nav-configuration">
                        <mat-icon class="nav-icon" aria-hidden="true">settings</mat-icon>
                        <span class="nav-label">Configuration</span>
                    </a>
                </li>
            </ul>

            <!-- Integrations: where the chatbot talks to visitors, one page per kind.
                 Tools: what it can do while it talks. -->
            <!-- One box around the heading and its list, so the first-run tour can highlight the section. -->
            <div data-tour="nav-integrations">
                <p class="nav-group" id="nav-group-integrations">Integrations</p>
                <ul class="nav-list" aria-labelledby="nav-group-integrations">
                    <li>
                        <a class="nav-item" routerLink="/integrations/widget" routerLinkActive="is-active">
                            <mat-icon class="nav-icon" aria-hidden="true">chat</mat-icon>
                            <span class="nav-label">Widget</span>
                            <nubo-status-dot
                                *ngIf="widgetNeedsAttention"
                                class="nav-trailing"
                                tone="warning"
                                label="Needs attention: no widget can load on a website yet"
                                matTooltip="No widget can load on a website yet"
                                matTooltipPosition="right"></nubo-status-dot>
                        </a>
                    </li>
                    <li>
                        <a class="nav-item" routerLink="/integrations/whatsapp" routerLinkActive="is-active">
                            <mat-icon class="nav-icon" aria-hidden="true">forum</mat-icon>
                            <span class="nav-label">WhatsApp</span>
                            <nubo-badge class="nav-trailing" tone="neutral" [caps]="true">Soon</nubo-badge>
                        </a>
                    </li>
                </ul>
            </div>

            <p class="nav-group" id="nav-group-tools">Tools</p>
            <ul class="nav-list" aria-labelledby="nav-group-tools">
                <li>
                    <a class="nav-item" routerLink="/tools/mcp-servers" routerLinkActive="is-active">
                        <mat-icon class="nav-icon" aria-hidden="true">dns</mat-icon>
                        <span class="nav-label">MCP Servers</span>
                    </a>
                </li>
                <li>
                    <a class="nav-item" routerLink="/tools/http-actions" routerLinkActive="is-active">
                        <mat-icon class="nav-icon" aria-hidden="true">bolt</mat-icon>
                        <span class="nav-label">HTTP Actions</span>
                    </a>
                </li>
            </ul>

            <p class="nav-group" id="nav-group-developer">Developer</p>
            <ul class="nav-list" aria-labelledby="nav-group-developer">
                <li>
                    <a class="nav-item" routerLink="/developer" routerLinkActive="is-active">
                        <mat-icon class="nav-icon" aria-hidden="true">code</mat-icon>
                        <span class="nav-label">API &amp; keys</span>
                    </a>
                </li>
            </ul>
        </nav>

        <div class="rail-foot">
            <span class="rail-foot-text">© {{ year }} Nubo</span>
        </div>
    </mat-sidenav>

    <mat-sidenav-content>
        <div class="top-bar-wrapper">
            <button *ngIf="isMobile" mat-icon-button (click)="sidenav.toggle()" class="hamburger-btn" aria-label="Open navigation menu">
                <mat-icon>menu</mat-icon>
            </button>
            <app-top-bar></app-top-bar>
        </div>

        <main id="main-content" tabindex="-1" class="main-content">
            <router-outlet></router-outlet>
        </main>
    </mat-sidenav-content>
</mat-sidenav-container>

<app-tour></app-tour>
